export default __webpack_public_path__ + "static/media/25_Cocen.9fe61e27.png";